// ANGULAR
import { Injectable } from '@angular/core';

// NGRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

// RXJS
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap, switchMap, tap, withLatestFrom } from 'rxjs/operators';

// EXTERNAL DEPENDENCY
import { get } from 'lodash';

// SERVICES
import { DashBoardService } from '../services/dashboard.service';

// ACTIONS AND STATES
import * as globalActions from '../../../global/store/actions';
import { State } from '../../../root-state';
import * as DashboardActions from './actions';

// COMMON INTERFACES AND ENUMS
import { ModalType } from '../../../../models/common/modal/modal-config';

// CONSTANT
import { DASHBOARD_NGRX_CONSTANTS } from '../../../../constants/ngrx-store/dashboard';



@Injectable()
export class DashboardEffects {
  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private dashboardService: DashBoardService) { }

  /**
   * @param type : Dashboard action name.
		  * Dashboard Effect
		  * @param payload : object to identify common Dashboard method base on module and method.
		  * @returns Empty action dispatch to reducer.
		  */
  DashboardCommonEffect$ = createEffect(() => this.actions$.pipe(
    ofType<DashboardActions.DashboardCommonAction>(DashboardActions.ActionTypes.DASHBOARD_COMMON),
    withLatestFrom(this.store),
    switchMap(([action, state]): Observable<any> => {
      // get common constant base action module and method.
      // changed to payload type from payload.data.method
      const common = DASHBOARD_NGRX_CONSTANTS[action.payload.module][action.payload.method];

      // avoid service call if data already exists in store.
      if (state[common.STATE]) {
        return of(new globalActions.EmptyAction({}));
      }
      // Only sending payload data

      return this.dashboardService[common.API_METHOD](action.payload.data)
        .pipe(

          mergeMap((data: any) => {
            // throwing an error on if the status is not 200
            if (data.status !== 200) { return throwError(data); }
            let actions: any[] = [];


            // dispatch Dashboard success action
            actions = [new DashboardActions.DashboardCommonSuccessAction({ data, common })];

            if (common.SUCCESS_NOTIFICATION) {
              // dispatch popup notification for open success popup
              actions.push(new globalActions.PopupNotificationAction({
                actionType: DashboardActions.ActionTypes.DASHBOARD_COMMON, type: ModalType.SUCCESS,
                callback: action.payload.callback, title: common.TITLE, message: common.SUCCESS,
                code: `${common.SUCCESS}`, response: data,
              }));
            } else {
              action.payload.callback({ success: true, data: get(data, common.API_RESPONSE) });
            }

            return actions;
          }),
          catchError(error => {
            console.error(error);

            return of(new globalActions.PopupNotificationAction({
              actionType: DashboardActions.ActionTypes.DASHBOARD_COMMON, type: ModalType.ERROR,
              message: error && error.error && error.error.message, callback: action.payload.callback, error: (error || error.error),
              // code: `ERROR.${error.code || error.error.code}`,
              title: common.TITLE,
            }));
          },
            // dispatch popup notification for open error popup
          ));
    }),
  ));
}
